import { EeCodeRecord, ProjectCharge } from "~/gql/types";

/**
 * Finds the EE code record for the charge's EE code string, so the form can be
 * seeded with the record the EE code picker expects. Throws when the loaded EE
 * codes have no record for it: the form can't show or save a code it can't
 * resolve.
 */
export const resolveInitialEeCode = (
  charge: ProjectCharge,
  eeCodes: EeCodeRecord[]
): EeCodeRecord => {
  const eeCode = eeCodes.find((x) => x.eeCode === charge.eeCode);

  if (!eeCode) {
    throw new Error(
      `No EE code record matches the charge's EE code "${charge.eeCode}".`
    );
  }

  return eeCode;
};
